import { render, staticRenderFns } from "./TicketIcon.vue?vue&type=template&id=be4abada&scoped=true"
import script from "./TicketIcon.vue?vue&type=script&lang=js"
export * from "./TicketIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4abada",
  null
  
)

export default component.exports